import { BUILD, ORDERED_OPTIONS } from '@consts/index'
import { FilterOption } from 'types/filters'
import { Collection } from 'types/collection'
import { ProductFeed } from 'types/product'

export type OptionType =
  | 'waist'
  | 'build'
  | 'inches'
  | 'length'
  | 'chest'
  | 'cut'
  | 'size'
  | 'trousers'
  | 'shorts'
  | 'tops'
  | 'shortsleg'
  | 'swimshortsleg'
  | 'leg'

export function getCollectionFiltersState(
  selectedFilterOptions: FilterOption[],
  fitAttribute: string,
  selectedOption: string
) {
  const newFilterOptions = [...selectedFilterOptions]

  const filterOptionindex = selectedFilterOptions.findIndex(
    option => option.type?.toLowerCase() === fitAttribute?.toLowerCase()
  )

  const newFilterOption = {
    type: fitAttribute,
    position:
      1 +
      ORDERED_OPTIONS.findIndex(
        fitType => fitAttribute === fitType.toLowerCase()
      ),
    value: selectedOption.replace(BUILD, '').trim()
  }
  if (filterOptionindex === -1) {
    newFilterOptions.push(newFilterOption)
  } else if (
    newFilterOptions[filterOptionindex].value?.toLowerCase() ===
    selectedOption?.toLowerCase()
  ) {
    newFilterOptions.splice(filterOptionindex, 1)
  } else {
    newFilterOptions[filterOptionindex] = { ...newFilterOption }
  }
  return newFilterOptions
}

export const filterByProductFeed = (
  collections: Collection[],
  productStyle: string,
  type = 'style'
) => {
  return collections
    .map(collection => {
      const items = collection.items.filter(item => {
        if (type === 'style') {
          return [item.product_feed.style?.toLowerCase()].includes(
            productStyle.toLowerCase()
          )
        }
        if (type === 'group') {
          return [
            item.product_feed.ecom_product_grouping?.toLowerCase()
          ].includes(productStyle.toLowerCase())
        }
        return [item.product_feed.ecom_product_header?.toLowerCase()].includes(
          productStyle.toLowerCase()
        )
      })

      return { ...collection, items }
    })
    .filter(collection => collection.items.length > 0)
}

export const getAvailableProductStyles = (collections: Collection[]) => {
  const filtersByStyle = getProductFeedValues(collections, 'style')
  const newSetFilters = ['All', ...new Set(filtersByStyle)]

  return newSetFilters
}

export const getEcomProductCategoriesByType = (
  collections: Collection[],
  type: keyof ProductFeed
) => {
  const categories = getProductFeedValues(collections, type)

  return ['All', ...new Set(categories)]
}

const getProductFeedValues = (
  collections: Collection[],
  field: keyof ProductFeed
) => {
  const values = collections
    .flatMap(collection =>
      collection.items.map(item => item.product_feed[field])
    )
    .filter(Boolean)

  return values
}
